import React, { useState, useCallback } from 'react';
import { OverlayTrigger, Tooltip as RTooltip } from 'react-bootstrap';
import PropTypes from "prop-types";

/**
 * Neighbor `Tooltip` was used in a bunch of places, while having its "return" essentially commented out.
 * This `TooltipNew` is basically a clone, but with that comments disabled / with proper return;
 * cloned because reason behind comment is unclear / to minimize affected area.
 */

const TooltipNew = ({
    placement = 'top',
    hide = false,
    id,
    tooltip,
    theme,
    icon = 'fa fa-question-circle',
    customStyle = {}
}) => {
    const [shouldUpdatePosition, setShouldUpdatePosition] = useState(false);

    const updatePosition = useCallback(() => {
        setShouldUpdatePosition(true);
    }, []);

    const getTheme = useCallback(() => {
        return theme ? `tooltip_${theme}` : '';
    }, [theme]);

    const getTooltip = useCallback(() => {
        if (React.isValidElement(tooltip)) {
            return React.cloneElement(
                tooltip,
                {
                    overlayID: id,
                    placement: placement,
                    updatePosition: updatePosition
                }
            );
        }

        return tooltip;
    }, [tooltip, id, placement, updatePosition]);

    const renderOverlayTrigger = useCallback(() => {
        if (hide) {
            return '';
        }
        return (
            <OverlayTrigger
                overlay={<RTooltip id={id} className={getTheme()}> {getTooltip()} </RTooltip>}
                placement={placement}
                shouldUpdatePosition={shouldUpdatePosition}
                delayHide={50}
            >
                <span className={icon} style={{...customStyle}} />
            </OverlayTrigger>
        );
    }, [hide, id, getTheme, getTooltip, placement, shouldUpdatePosition, icon]);

    if (hide) {
        return '';
    }

    return renderOverlayTrigger();
};

TooltipNew.propTypes = {
    placement: PropTypes.string,
    hide: PropTypes.bool,
    id: PropTypes.string,
    tooltip: PropTypes.string,
    theme: PropTypes.string,
};

export default TooltipNew;
